<script setup lang="ts">
import { ToastProvider } from '@shared/ui/toast'
import { AppLogo } from '@shared/ui/other'

defineOptions({
  name: 'AuthLayout',
})

</script>

<template>
  <div class="auth-layout">
    <AppLogo />
    <slot />
  </div>
  <ToastProvider />
</template>

<style scoped lang="scss" src="./auth-layout.scss" />